import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useInstitutionsAuthorization } from "@/features/accounts/shared/hooks/use-institutions-authorization";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { InstitutionsType } from "@/shared/config/globals"
import { SimpleForm } from "@/shared/components/text-box/simple-form";

interface Props {
  onTapCloseModal: () => void;
}

// 金融機関選択モーダル
export const InstitutionsAuthorizationModal = (props: Props) => {
  const {
      onTapCloseModal,
  } = props;
  const {
    institutionType,
    selectedInstitutionService,
  } = useInstitutionsContext();
  const { 
      requestInstitutionsAuthorizationSite
  } = useInstitutionsAuthorization();

  // 選択ボタンに付与するID
  const institutionsAuthorization = "institutions_authorization";

  //  遷移ボタン選択時
  const handleSelect = () => {
    if (!selectedInstitutionService) {
      return;
    }
    if ( selectedInstitutionService.industryCode === "01"
      && selectedInstitutionService.companyCode === "10005"
      && selectedInstitutionService.serviceCode === "1020"
    ) {
      localStorage.setItem("MitsubishiUfjCorp", "1");
      localStorage.setItem("industryCode", selectedInstitutionService.industryCode);
      localStorage.setItem("companyCode", selectedInstitutionService.companyCode);
      localStorage.setItem("serviceCode", selectedInstitutionService.serviceCode);
    }
    localStorage.setItem("companyName", selectedInstitutionService.companyName);
    localStorage.setItem("serviceName", selectedInstitutionService.serviceName);
    localStorage.setItem("branchName", selectedInstitutionService.branchName);
    // 金融機関認可サイトへ遷移
    requestInstitutionsAuthorizationSite();
  }

  const institutionTypeName = (() => {
    let name = "";
    switch (institutionType) {
      case InstitutionsType.Bank:
        name = "銀行口座";
        break;
      case InstitutionsType.Card:
        name = "クレジットカード";
        break;
      case InstitutionsType.ElectronicMoney:
        name = "電子マネー";
        break;
      case InstitutionsType.Other:
        name = "その他サービス";
        break;
    }
    return name;
  })();

  return (
    <BasePageModal
      title={`${institutionTypeName}用Web明細帳を作成`}
      className={`md-add-bank ${institutionType}`}
      disableOverlayClose={true}
      handleClose={() => {
      onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText={`${selectedInstitutionService?.companyName}のサイトへ移動`}
          onClick={() => handleSelect()}
          isActive={true}
          id={institutionsAuthorization}
          loadingNegative={true}
        />
      }
    >
      <h2>
        金融機関の認証サイトへ移動します
      </h2>
      <dl>
        <SimpleForm
          id="companyName"
          initialValue={selectedInstitutionService?.companyName}
          isReadOnly={true}
          title="金融機関"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
        <SimpleForm
          id="serviceName"
          initialValue={selectedInstitutionService?.serviceName}
          isReadOnly={true}
          title="サービス"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
      </dl>
      <div className="notice">
        <p>
          上記で口座登録を開始します。<br />
          金融機関サイトで認証を行ってください。
        </p>
      </div>
    </BasePageModal>
  );
};